import React from 'react';

const AuthLayout = ({ 
  title, 
  subtitle, 
  children,
  platform,
  showBackgroundPattern = true 
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {showBackgroundPattern && (
        <div className="absolute inset-0 bg-gray-50">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100 opacity-50"></div>
        </div>
      )}
      
      <div className="relative max-w-md w-full space-y-8">
        <div className="bg-white rounded-2xl shadow-xl ring-1 ring-gray-900/5 p-8 sm:p-10">
          <div className="text-center mb-8">
            <img
              className="mx-auto h-12 w-auto mb-4"
              src="/logo-light.png"
              alt="Loope Logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 mb-2">
              {title}
            </h2>
            {platform && (
              <span className="inline-flex items-center rounded-full bg-green-50 px-3 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 mb-3">
                {platform}
              </span>
            )}
            {subtitle && (
              <p className="text-sm text-gray-600">
                {subtitle}
              </p>
            )}
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
